export default __webpack_public_path__ + "KaTeX_SansSerif-Bold.2946bdb590f9bd4c7ba30978a7eafa68.woff";